<div class="outer" [ngClass]="{ 'has-error': model.hasError }">
  <div
    class="nwx-card-header bolt-container-fluid"
    id="hubPolicySummaryCardHeader-{{ model.id }}"
    >
    @if (model.staticTextHeader) {
      <div class="staticTextHeader">
        {{ model.staticTextHeader }}
      </div>
    }
    <div>
      @switch (model.syncStatus) {
        @case ('Clean') {
          <div class="sync-clean">Included &#x2713;</div>
        }
        @case ('SetByBackend') {
          <div class="sync-clean">
            Included &#x2713;
          </div>
        }
        @case ('Dirty') {
          <div class="sync-dirty">* Unsaved changes</div>
        }
        @case ('CallInProgress') {
          <div class="sync-in-progress">
            Updating...
          </div>
        }
      }
    </div>
    <div class="hub-header-headline" id="hcs-header-headline-{{ model.id }}">
      {{ model.headline }}
    </div>
    @if (model.description) {
      <div
        id="hcs-header-description-{{ model.id }}"
        class="hub-header-description"
        >
        {{ model.description }}
      </div>
    }
  </div>
  @if (model.unselectOption) {
    <div class="bolt-col-2">
      <bolt-button
        (click)="onUnselect()"
        iconleft="xmark"
        class="nwx-borderless-bolt-button"
      ></bolt-button>
    </div>
  }
  <div>
    <ng-template #form></ng-template>
  </div>
</div>
